import { createSelector } from 'reselect';
import {
  DEFAULT_LATITUDE,
  DEFAULT_LONGITUDE,
  DEFAULT_ZOOM,
  NO_DEPOT_ZOOM,
} from './map';

import { getUserDepots } from './user';
import { ENVIRONMENT_MODE } from '../../constants/app';
import { allowCloseTote } from '../../models/depot';

export const getAppState = (state) => state.routePlannerApp;

export const getSelectedDepot = createSelector(
  getAppState,
  ({ selectedDepot }) => selectedDepot
);

export const getSelectedDepotLocation = createSelector(
  getUserDepots,
  getSelectedDepot,
  (depots, selectedDepot) => {
    const depot = depots.find(({ depotCode }) => depotCode === selectedDepot);

    if (!depots.length || !selectedDepot || !depot) {
      return {
        coordinates: [DEFAULT_LONGITUDE, DEFAULT_LATITUDE],
        zoom: [NO_DEPOT_ZOOM],
      };
    }

    return {
      coordinates: [depot.longitude, depot.latitude],
      zoom: [DEFAULT_ZOOM],
    };
  }
);

export const getSelectedDepotAccessData = createSelector(
  getUserDepots,
  getSelectedDepot,
  (depots, selectedDepot) =>
    depots.find(({ depotCode }) => depotCode === selectedDepot)
);

export const allowToteTransfers = createSelector(
  getSelectedDepotAccessData,
  (depotAccess) => depotAccess && depotAccess.allowToteTransfers
);

export const allowConsignmentSplitting = createSelector(
  getSelectedDepotAccessData,
  (depotAccess) => depotAccess && depotAccess.allowConsignmentSplitting
);

export const getBulkStopThreshold = createSelector(
  getSelectedDepotAccessData,
  (depotAccess) => depotAccess && depotAccess.bulkParcelCount
);

export const isDisasterRecoveryMode = createSelector(
  getSelectedDepotAccessData,
  (selectedDepotData) =>
    selectedDepotData &&
    selectedDepotData.environmentMode === ENVIRONMENT_MODE.DISASTER_RECOVERY
);

export const hasDepotAllowCloseTote = createSelector(
  getUserDepots,
  getSelectedDepot,
  allowCloseTote
);
